import {EnvService} from "../../../services/Env.service";
import {AuthService} from "../../../services/Auth.service";
import {Navigate} from "react-router-dom";

interface RequiresAuthProps {
    children: JSX.Element;
}
export function RequiredAuth  ({children}: RequiresAuthProps)  {
    if (!EnvService.authModeIsMock()) {
        if (!AuthService.hasValidToken()) {
            AuthService.clearSession();
            return <Navigate to="/login" replace/>;
        }
    }


    return children;
}